export const breakpoints = {
  s: 'max-width: 570px',
  mobile: 'max-width: 850px',
  tablet: 'max-width: 1000px',
  desktop: 'min-width: 1081px',
  desktopL: 'min-width: 1200px',
  desktopS: 'max-width: 1200px',
};
